import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/Authentication/authentication.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private authenticationService: AuthenticationService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(catchError(err => {
      try {
        console.log('inside error interceptor');
        console.log(err);
        if (([401, 403].indexOf(err.status) !== -1) || (err.error.text.includes('<!DOCTYPE html>'))) {
          // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
          console.log('found logout error code inside interceptor.');
          this.authenticationService.logout();
        }
      } catch (error) {
        console.log('error in interceptor' + error);
      }
      const error = err.status || err.statusText || err.error|| err.error.message || err.error.error;
      return throwError(error);
  }));
  }
}
